// /clients dispatch: internal staff get the company-mapping admin; reps get their assigned book.
import { useAuthStore } from '../stores/authStore.js';
import Clients from './Clients.jsx';
import RepClients from './RepClients.jsx';

export default function ClientsIndex() {
  const role = useAuthStore((s) => s.user?.role);
  return role === 'INTERNAL_STAFF' ? <Clients /> : <RepClients />;
}
